import { render } from "./sidemenuPage.vue?vue&type=template&id=a21af5ba"
import script from "./sidemenuPage.vue?vue&type=script&lang=js"
export * from "./sidemenuPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yuviony/vspl/ui/vetaconnect_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__